// import getAuthHeaders from './AuthHeader';
// import decode from 'jwt-decode';
// import moment from 'moment';
// import { MINUTE_MILLIS, REFRESHER_MINUTES, MAX_RETRY_ON_TOKEN_REFRESH, WAITING_TIME_FOR_TOKEN_REFRESH } from "../Constants/constants"

const getApiURL = () => process.env.REACT_APP_API_CORE_URL;

export default class BaseAPI {
  // Initializing important variables

  static authToken;

  static refreshToken;

  static refreshTokenExpiration;

  static tokenRefresherInterval

  static authIsRefreshing = false;

  constructor() {
    this.apiBaseURL = getApiURL();
    this.buildJsonHeaders = this.buildJsonHeaders.bind(this);
    this.makeHttpRequest = this.makeHttpRequest.bind(this);
    // this.buildCustomHeaders = this.buildCustomHeaders.bind(this);

    this.patchJson = this.patchJson.bind(this);
    this.getJson = this.getJson.bind(this);
  }

  // Add custom headers to a request
  // buildCustomHeaders(isAuth,headers){
  //     console.log(headers);
  //     if(isAuth){
  //         return Object.assign({},headers,getAuthHeaders());
  //     }else{
  //         return headers;
  //     }
  // }

  // Return json headers to use in a request.
  buildJsonHeaders = () => ({
    'Content-Type': 'application/json',
    Accept: 'application/json',
    // 'x-forwarded-for': process.env.REACT_APP_ENV === 'LOCAL' ? '127.0.0.1' : undefined,
  })

  // Return json headers to use in a request.
  buildJsonHeadersWithAppVersion = () => {
    var headers = this.buildJsonHeaders();

    headers['version'] = 99;

    return headers;
  }

  // getJson(url,headers) {
  //     return fetch(this.apiBaseURL + url, {
  //         method: 'GET',
  //         headers: headers ? this.buildCustomHeaders(false,headers) : this.buildJsonHeaders()
  //     })
  //     .then((response) => {
  //         if (response.ok) {
  //             return Promise.resolve(response)
  //         } else {
  //             return Promise.reject(response)
  //         }
  //     });
  // }

  makeHttpRequest = async (url, opts) => fetch(this.apiBaseURL + url, opts)
    .then((response) => {
      if (response.ok) {
        return Promise.resolve(response);
      }
      return Promise.reject(response);
    })

  // Executes a PUT request without authorization.
  patchJson = async (url, content) => {
    const opts = {
      method: 'PATCH',
      headers: this.buildJsonHeadersWithAppVersion(),
      body: JSON.stringify(content),
    };

    return new Promise(async (resolve, reject) => {
      await this.makeHttpRequest(url, opts)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getJson = async (url) => {
    const opts = {
      method: 'GET',
      headers: this.buildJsonHeaders(),
    };

    return new Promise((resolve, reject) => {
      this.makeHttpRequest(url, opts)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  // Executes a POST request without authorization.
  postJson = async (url, content) => {
    const opts = {
      method: 'POST',
      headers: this.buildJsonHeaders(),
      body: JSON.stringify(content),
    };

    return new Promise(async (resolve, reject) => {
      await this.makeHttpRequest(url, opts)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  postFile = async (url, file) => {
    const formData = new FormData();
    formData.append('source', file);

    const opts = {
      method: 'POST',
      body: formData,
    };

    return new Promise((resolve, reject) => {
      this.makeHttpRequest(url, opts)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  postFileWithProgress = (url, file, progressCallback) => new Promise((resolve, reject) => {
    const data = new FormData();
    data.append('source', file);

    const request = new XMLHttpRequest();
    request.open('POST', this.apiBaseURL + url);

    // upload progress event
    request.upload.addEventListener('progress', (e) => {
      // upload progress as percentage
      const percentCompleted = (e.loaded / e.total) * 100;
      progressCallback(percentCompleted);
    });

    // request finished event
    request.addEventListener('load', () => {
      if (request.status !== 200) {
        reject(request.response);
      } else {
        resolve(request.response);
      }
    });

    // send POST request to server
    request.send(data);
  })
}
